import React from 'react';
import axios from 'axios';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

import { formatNull } from '../Utils/GlobalUtils';

import ApplicantCases from '../Components/DebtorComponents/ApplicantCases';
import CommentsApplicant from '../Components/DebtorComponents/CommentsDebtor';

import Loading from '../Components/Loading';
import WarningPanel from '../Components/WarningPanel';
import HeadlinePanel from '../Components/HeadlinePanel';

import IconContainer from '../Components/IconContainer';
import { ReactComponent as PenIcon } from '../icons/pen.svg';

export default function PageOfApplicant() {
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();

    const [applicantInfo, setApplicantInfo] = React.useState([]);
    const [reload, setReload] = React.useState(true);
    const [loading, setLoading] = React.useState(true);
    const [warning, setWarning] = React.useState('');
    const [status, setStatus] = React.useState(<a>Сохраните изменения</a>);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        
        axios.get(`/api/get-full-info-applicant?id=${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then((response) => {
            setWarning('');
            setApplicantInfo(response.data);
            document.title = `${response.data.name} — Личный кабинет Альянс`;
        })
        .catch((error) => {
            console.error(error);
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        })
        .finally(() => {
            setReload(false);
            setLoading(false);
        });
    }, [reload, id]);

    const [access, setAccess] = React.useState(false);
    React.useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get('/api/get-my-user-role', {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            const hasAccess = response.data.role == 'АппаратСРО';
            setAccess(hasAccess);
        }).catch(err => {
            console.error(`Ошибка получения данных: ${err}`);
        })
    }, []);
   
    return (
        <div className='mainContainer'>
            <HeadlinePanel label='Карточка заявителя' type='Назад' />
            <div className='containerInner'>
                <div className='pageWrapper'>
                    <div className='pageLimiter'>
                        {loading ? <Loading />
                        : warning ? <WarningPanel text={warning} buttonText='Повторить попытку' buttonAction={() => {setLoading(true)}} />
                        : 
                        <>
                            <div className='iconTopRight'>
                                <button
                                    type='button'
                                    className='miniButton'
                                    onClick={() => navigate(`/change-applicant/${applicantInfo.id}`)}
                                >
                                    <IconContainer
                                        Icon={PenIcon}
                                        isClickable={false}
                                        size='16'
                                        color='blue'
                                    />
                                    Изменить данные
                                </button>
                            </div>
                            <div className='labelInputWrapper'>
                                <a className='label'>Наименование или ФИО</a>
                                <div className='labelInputRight paddingRight'>
                                    <a>{formatNull(applicantInfo.name)}</a>
                                </div>
                            </div>
                            <div className='labelInputWrapper'>
                                <a className='label'>Примечание</a>
                                <div className='labelInputRight'>
                                    <a>{formatNull(applicantInfo.description)}</a>
                                </div>
                            </div>
                            <div className='labelInputWrapper'>
                                <a className='label'>Карточки, к которым прикреплен заявитель</a>
                                <div className='labelInputRight'>
                                    <ApplicantCases
                                        applicantId={id}
                                        case_ids={applicantInfo.case_ids || []}
                                        reload={reload}
                                        onSuccess={() => setReload(true)}
                                        access={access}
                                        isShowButtons={true}
                                    />
                                </div>
                            </div>
                            {/* <h3 className='formHeadline'>Связь</h3>
                            <div className='labelInputWrapper'>
                                <a className='label'>Сообщения</a>
                                <div className='labelInputRight'>
                                    <CommentsDebtor debtorId={applicantInfo.id} access={access} userId={applicantInfo.user_id} onSuccess={() => {setReload(true)}} />
                                </div>
                            </div> */}

                            <div style={{height: '50px'}}></div>
                        </>}
                    </div>
                </div>
            </div>
        </div>
    )
}
